/* Waïloa – sections éditoriales « wl-ed » : révélations, manifeste, compteurs, parallaxe,
   défilement horizontal, hotspots « Shop the look », vidéos. Vanilla, sans dépendance. */
(function () {
  if (window.WLED) return;
  window.WLED = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Apparitions ---------- */
  var io = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }) : null;
  function reveal(root) {
    root.querySelectorAll('[data-r],.wed-rv,.wed-tl__item,.wed-pl__it,[data-lines]').forEach(function (el) {
      if (el.dataset.wedR) return; el.dataset.wedR = 1;
      if (!io || reduce) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---------- Manifeste : mots qui s'allument au défilement ---------- */
  function splitWords(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) { if (n.nodeValue.trim()) nodes.push(n); }
    nodes.forEach(function (t) {
      var frag = document.createDocumentFragment();
      t.nodeValue.split(/(\s+)/).forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
        var s = document.createElement('span'); s.className = 'wed-w'; s.textContent = w; frag.appendChild(s);
      });
      t.parentNode.replaceChild(frag, t);
    });
    return el.querySelectorAll('.wed-w');
  }
  var scrubs = [];
  function initScrub(sec) {
    if (reduce || sec.dataset.wedS) return; sec.dataset.wedS = 1;
    var txt = sec.querySelector('.wed-mani__txt'); if (!txt) return;
    scrubs.push({ el: txt, words: splitWords(txt), last: -1 });
  }
  function runScrub() {
    var vh = window.innerHeight;
    scrubs.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var k = Math.round(p * s.words.length);
      if (k === s.last) return; s.last = k;
      for (var i = 0; i < s.words.length; i++) s.words[i].classList.toggle('is-on', i < k);
    });
  }

  /* ---------- Parallaxe douce ---------- */
  var pars = [];
  function runPar() {
    var vh = window.innerHeight;
    pars.forEach(function (el) {
      var r = el.parentNode.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var f = parseFloat(el.getAttribute('data-ed-par')) || 0.08;
      var c = (r.top + r.height / 2 - vh / 2);
      el.style.transform = 'translate3d(0,' + (c * -f).toFixed(1) + 'px,0) scale(' + (1 + f * 3).toFixed(3) + ')';
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; runScrub(); runPar(); });
  }

  /* ---------- Compteurs ---------- */
  function initCount(el) {
    if (el.dataset.wedC) return; el.dataset.wedC = 1;
    var to = parseFloat(el.getAttribute('data-ed-count')); if (isNaN(to)) return;
    var dec = (String(el.getAttribute('data-ed-count')).split('.')[1] || '').length;
    var fmt = function (v) { return v.toLocaleString(document.documentElement.lang || 'fr', { minimumFractionDigits: dec, maximumFractionDigits: dec, useGrouping: false }); };
    if (reduce || !hasIO) { el.textContent = fmt(to); return; }
    el.textContent = fmt(0);
    var o = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; o.disconnect();
      var t0 = null, d = 1600;
      (function step(ts) {
        if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / d); p = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(to * p); if (p < 1) requestAnimationFrame(step);
      })(performance.now());
    }, { threshold: 0.4 });
    o.observe(el);
  }

  /* ---------- Défilement horizontal ---------- */
  function initTrack(wrap) {
    if (wrap.dataset.wedT) return; wrap.dataset.wedT = 1;
    var tr = wrap.querySelector('.wed-track'); if (!tr) return;
    var prev = wrap.querySelector('[data-ed-prev]'), next = wrap.querySelector('[data-ed-next]'), bar = wrap.querySelector('.wed-prog span');
    function step() { var li = tr.querySelector('li'); return li ? li.getBoundingClientRect().width + 20 : tr.clientWidth * 0.8; }
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth;
      if (bar) bar.style.setProperty('--p', max > 0 ? Math.max(0.08, (tr.scrollLeft + tr.clientWidth) / tr.scrollWidth).toFixed(3) : 1);
      if (prev) prev.disabled = tr.scrollLeft < 4;
      if (next) next.disabled = tr.scrollLeft > max - 4;
    }
    if (prev) prev.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    /* glisser à la souris (desktop) */
    var down = false, sx = 0, sl = 0, moved = false;
    tr.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = tr.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; tr.classList.add('is-drag'); } tr.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { tr.classList.remove('is-drag'); }, 0); });
    tr.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    upd();
  }

  /* ---------- Hotspots « Shop the look » ---------- */
  var openSpot = null;
  function closeSpot() {
    if (!openSpot) return;
    openSpot.setAttribute('aria-expanded', 'false');
    var p = document.getElementById(openSpot.getAttribute('aria-controls'));
    if (p) { p.classList.remove('is-open'); p.setAttribute('hidden', ''); }
    openSpot = null;
  }
  function placePop(btn, pop) {
    var fig = btn.closest('.wed-look'); if (!fig || window.innerWidth < 750) return;
    var fr = fig.getBoundingClientRect(), br = btn.getBoundingClientRect(), pw = pop.offsetWidth, ph = pop.offsetHeight;
    var x = br.left - fr.left + br.width / 2, y = br.top - fr.top + br.height / 2;
    var left = x + 28; if (left + pw > fr.width - 8) left = x - pw - 28; if (left < 8) left = 8;
    var top = y - ph / 2; top = Math.max(8, Math.min(top, fr.height - ph - 8));
    pop.style.left = left + 'px'; pop.style.top = top + 'px';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.wed-spot');
    if (b) {
      e.preventDefault();
      var was = openSpot === b; closeSpot(); if (was) return;
      var p = document.getElementById(b.getAttribute('aria-controls')); if (!p) return;
      p.removeAttribute('hidden'); placePop(b, p);
      requestAnimationFrame(function () { p.classList.add('is-open'); });
      b.setAttribute('aria-expanded', 'true'); openSpot = b;
      return;
    }
    if (e.target.closest && e.target.closest('.wed-pop__x')) { var s = openSpot; closeSpot(); if (s) s.focus(); return; }
    if (openSpot && !(e.target.closest && e.target.closest('.wed-pop'))) closeSpot();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openSpot) { var s = openSpot; closeSpot(); s.focus(); } });
  window.addEventListener('resize', closeSpot);

  /* ---------- Vidéos : lecture seulement si visibles ---------- */
  function initVid(v) {
    if (v.dataset.wedV) return; v.dataset.wedV = 1;
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    if (!hasIO) { v.play && v.play().catch(function () {}); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: 0.15 }).observe(v);
  }

  /* ---------- Formulaire contact : sujet pré-rempli via ?sujet= ---------- */
  function initForm(f) {
    if (f.dataset.wedF) return; f.dataset.wedF = 1;
    var q = new URLSearchParams(location.search).get('sujet'); if (!q) return;
    q = q.toLowerCase();
    f.querySelectorAll('input[name="contact[Sujet]"]').forEach(function (r) { if (r.value.toLowerCase().indexOf(q) > -1) r.checked = true; });
  }

  function init(root) {
    root = root || document;
    reveal(root);
    root.querySelectorAll('.wed-mani--scrub').forEach(initScrub);
    root.querySelectorAll('[data-ed-count]').forEach(initCount);
    root.querySelectorAll('[data-ed-hs]').forEach(initTrack);
    root.querySelectorAll('.wed video').forEach(initVid);
    root.querySelectorAll('.wed-ct form').forEach(initForm);
    if (!reduce) root.querySelectorAll('[data-ed-par]').forEach(function (el) { if (pars.indexOf(el) < 0) pars.push(el); });
    onScroll();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
